var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowButton = function SvgArrowButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none",
    viewBox: "0 0 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#252655",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M18.849 36.698C8.995 36.698 1 28.702 1 18.847 1 8.996 8.995 1 18.85 1s17.849 7.984 17.849 17.849c-.011 9.865-7.995 17.848-17.85 17.848Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#252655",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "m18.67 10.316 8.89 8.197-8.196 8.88M27.56 18.513H10.137"
  })));
};
export default SvgArrowButton;